import React from 'react';

import { ReadProfileVisibility } from './ReadProfileVisibility/ReadProfileVisibilityContainer';
import { useGetProfileVisibility, useGetShareableProfileStatus } from './data';

export const ProfileVisibilityV2Container = () => {
  const { loading: profileVisibilityLoading, error: profileVisibilityError } =
    useGetProfileVisibility();
  const {
    loading: shareableProfileStatusLoading,
    error: shareableProfileStatusError,
  } = useGetShareableProfileStatus();

  const loading = profileVisibilityLoading || shareableProfileStatusLoading;
  const error = profileVisibilityError || shareableProfileStatusError;

  return <ReadProfileVisibility loading={Boolean(loading || error)} />;
};
